import { render } from "./edit.vue?vue&type=template&id=001a0219&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import "./edit.vue?vue&type=style&index=0&id=001a0219&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-001a0219"],['__file',"src/views/modelSetting/modelInstance/edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "001a0219"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('001a0219', __exports__)) {
    console.log('reload')
    api.reload('001a0219', __exports__)
  }
  
  module.hot.accept("./edit.vue?vue&type=template&id=001a0219&scoped=true", () => {
    console.log('re-render')
    api.rerender('001a0219', render)
  })

}


export default __exports__